module.exports = __webpack_public_path__ + "static/media/Top.d06effc8.png";